import { Button } from 'components/Button';

import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';

type IDialogCustom = {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  loading?: boolean;
};

export const DialogCustom: React.FC<IDialogCustom> = ({
  title,
  text,
  isOpen,
  onClose,
  onClick,
  variant = 'text',
  loading,
}) => {
  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ minWidth: 500 }}>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid container spacing={2} justifyContent="flex-end" mb={1} mr={1}>
          <Button onClick={handleClose} variant={variant} disabled={loading}>
            Não
          </Button>

          <Button
            onClick={onClick}
            variant={variant}
            disabled={loading}
            loading={loading}
          >
            Sim
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
